<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>
    <!--Laboratory form  -->
    <div class="ui form" [formGroup]="applicationForm">
      <!-- <div class="ui form side-panel" fxLayout="row"
                  fxLayoutAlign='start center'
                  fxLayoutGap='50px'
                  appPadding="15px"
                    appMargin marginB="30px">
                  <svg fxFlex="10%" width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="1" y="1" width="50" height="50" rx="5" stroke="#999999" stroke-width="2" stroke-dasharray="4 4"/>
                        </svg>

                  <div fxFlex="grow">Upload Picture</div>
                  <div fxFlex>
                  <button  class="ui tiny icon button">
                        <i class="upload icon"></i>
                  </button>
                  </div>
               </div> -->
      <div class="field" [ngClass]="displayFieldCss('applicationName')">
        <label>Application Name</label>
        <input
          formControlName="applicationName"
          type="text"
          placeholder="Enter application name"
        />
        <app-field-error-display
          [displayError]="isFieldValid('applicationName')"
          errorMsg="Please enter application name"
        >
        </app-field-error-display>
      </div>
      <div class="field" [ngClass]="displayFieldCss('applicationId')">
        <label>Application Id</label>
        <input
          formControlName="applicationId"
          type="text"
          placeholder="Enter application id"
        />
        <app-field-error-display
          [displayError]="isFieldValid('applicationId')"
          errorMsg="Please enter application id"
        >
        </app-field-error-display>
      </div>
      <div class="field" [ngClass]="displayFieldCss('applicationHost')">
        <label>Application Host</label>
        <input
          formControlName="applicationHost"
          type="text"
          placeholder="Enter application host"
        />
        <app-field-error-display
          [displayError]="isFieldValid('applicationHost')"
          errorMsg="Please enter application host"
        >
        </app-field-error-display>
      </div>
      <div class="field" [ngClass]="displayFieldCss('paymentCallBackUrl')">
        <label>Application Payment Callback URL</label>
        <input
          formControlName="paymentCallBackUrl"
          type="text"
          placeholder="Enter application callback url"
        />
        <app-field-error-display
          [displayError]="isFieldValid('paymentCallBackUrl')"
          errorMsg="Please enter application  callback url"
        >
        </app-field-error-display>
      </div>
      <div class="field" [ngClass]="displayFieldCss('applicationDescription')">
        <label>Application Description</label>
        <input
          formControlName="applicationDescription"
          type="text"
          placeholder="Enter application description"
        />
        <app-field-error-display
          [displayError]="isFieldValid('applicationDescription')"
          errorMsg="Please enter email address"
        >
        </app-field-error-display>
      </div>
      <!-- <div class="field" [ngClass]="displayFieldCss('applicationDescription')">
                              <label>Application Role URL</label>
							  <input  formControlName="applicationDescription" type="text" placeholder="Enter application role  url">
                            <app-field-error-display [displayError]="isFieldValid('applicationDescription')" errorMsg="Please enter email address">
                              </app-field-error-display>
                        </div>   -->
      <div class="field" [ngClass]="displayFieldCss('ordering')">
        <label>Application Ordering Number</label>
        <input
          formControlName="ordering"
          type="number"
          placeholder="Enter application ordering number"
        />
        <app-field-error-display
          [displayError]="isFieldValid('ordering')"
          errorMsg="Please enter application ordering number"
        >
        </app-field-error-display>
      </div>

      <div class="field" [ngClass]="displayFieldCss('hideFromDashboard')">
        <sui-checkbox formControlName="hideFromDashboard">
          Hide From Dashboard
        </sui-checkbox>
        <app-field-error-display
          [displayError]="isFieldValid('hideFromDashboard')"
          errorMsg="Please select department"
        >
        </app-field-error-display>
      </div>

      <div class="field" [ngClass]="displayFieldCss('accessTypes')">
        <label> Access Types</label>
        <sui-multi-select
          class="selection"
          formControlName="accessTypes"
          [options]="accessTypes"
          valueField="key"
          labelField="value"
          #multiSelect
        >
          <sui-select-option
            *ngFor="let option of multiSelect.filteredOptions"
            [value]="option"
          >
          </sui-select-option>
        </sui-multi-select>
        <app-field-error-display
          [displayError]="isFieldValid('accessTypes')"
          errorMsg="Please select access types"
        >
        </app-field-error-display>
      </div>
      <div class="field" [ngClass]="displayFieldCss('defaultUserRoles')">
        <label>Default Roles</label>
        <input
          formControlName="defaultUserRoles"
          type="text"
          placeholder="Enter application default roles"
        />
        <p>NOTE:Roles should be seperated by comma</p>
        <app-field-error-display
          [displayError]="isFieldValid('defaultUserRoles')"
          errorMsg="Please enter application ordering number"
        >
        </app-field-error-display>
      </div>
      <!-- <div class="field" [ngClass]="displayFieldCss('defaultUserRoles')">
        <label> Default Roles</label>
        <sui-multi-select
          class="selection"
          formControlName="defaultUserRoles"
          [options]="roles"
          valueField="roleId"
          labelField="roleName"
          #multiSelectd
        >
          <sui-select-option
            *ngFor="let option of multiSelectd.filteredOptions"
            [value]="option"
          >
          </sui-select-option>
        </sui-multi-select>
        <app-field-error-display
          [displayError]="isFieldValid('defaultUserRoles')"
          errorMsg="Please select roles"
        >
        </app-field-error-display>
      </div> -->
    </div>
  </div>
</div>

<div class="actions">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Cancel
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    [disabled]="!applicationForm.valid || pending"
    (click)="submit()"
    autofocus
  >
    Done
  </button>
</div>
